// Import dependencies
import React from 'react'
import axios from 'axios'
import cookie from 'js-cookie'
import { tokenize } from '../../../../helper'
import { Modal, Button } from 'react-bootstrap'

// Import styling
import './SettingsPage.css'
import AdminNavbar from '../../../reusables/adminNavbar'

// Import components
import AccountSettings from './accountSettings'
import LandingPageSettings from './landingPageSettings'

// Import config
import config from '../../../../configs/config.json'
const API_URL = config.API_URL
const ADMIN_API_URL = API_URL + '/admin'
const SETTINGS_URL = ADMIN_API_URL + '/settings'

const MESSAGE_LIMIT = 1600

class SettingsPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      liveStreamSettings: {
        eventID: {
          vimeoID: '',
          issuedDateTime: new Date(),
          issuedBy: ''
        },
        browserRefresh: {
          issuedDateTime: new Date(),
          issuedBy: ''
        },
        offlineMessage: {
          message: '',
          issuedDateTime: new Date(),
          issuedBy: ''
        },
        zoomLink: {
          link: '',
          issuedDateTime: new Date(),
          issuedBy: ''
        },
        zoomMessage: {
          message: '',
          issuedDateTime: new Date(),
          issuedBy: '',
          enabled: false
        },
        onlineStatus: {
          isOnline: false,
          issuedDateTime: new Date(),
          issuedBy: ''
        }
      },

      // Variables that control modal visibility
      showSubmitEventIDModal: false,
      showSubmitOfflineMessageModal: false,
      showSubmitZoomLinkModal: false,
      showSubmitZoomRedirectMessageModal: false,
      showToggleZoomRedirect: false,
      showToggleLiveStreamModal: false,
      showRefreshBrowsersModal: false,
      showFullViewThresholdModal: false,

      // Response messages to be displayed inside modals
      modalSuccess: false,
      modalMessage: '',

      // Full view percentage threshold
      fullViewThreshold: '',
      fullViewThresholdModified: new Date()
    }
  }

  componentDidMount = () => {
    var token = cookie.get('token')
    var user_type = cookie.get('user-type')

    if (token) {
      if (user_type === 'admin') {
        // Admin authorized, query the back-end for the login history
      } else {
        // Not authorized, re-direct to admin log in page
        window.location.href = '/admin'
      }
    } else {
      // No token found, re-direct them to admin log in page
      window.location.href = '/admin'
    }

    this.fetchLiveStreamSettings()
    this.fetchFullViewThreshold()
  }

  fetchFullViewThreshold = () => {
    axios
      .get(`${SETTINGS_URL}/analytics/threshold`, tokenize())
      .then(response => {
        var payload = response.data
        console.log("Threshold: ", payload)
        var { percentage, issued, name } = payload.threshold;

        if (payload.success) {
          this.setState({
            fullViewThreshold: percentage,
            fullViewThresholdModified: name + " " + (new Date(issued).toLocaleString())
          })
        }
      })
      .catch(error => { })
  }

  patchFullViewThreshold = () => {
    axios
      .patch(
        `${SETTINGS_URL}/analytics/threshold`,
        tokenize({ percentage: this.state.fullViewThreshold })
      )
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully updated full view threshold.'
          });

          this.fetchFullViewThreshold();
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to update full view threshold.'
          })
        }
      })
      .catch(error => {
        console.log(error => {
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to update full view threshold.'
          })
        })
      })
  }

  fetchLiveStreamSettings = () => {
    axios
      .get(`${SETTINGS_URL}/livestream`, tokenize())
      .then(response => {
        var payload = response.data
        console.log('LIVESTREAM SETTINGS: ', payload)
        if (payload.success) {
          // Settings received from back-end
          var dbSettings = payload.settings

          // Settings state variable
          var settings = this.state.liveStreamSettings

          console.log(settings)

          // Save zoom message & toggle to state
          settings.zoomMessage.message = dbSettings.ZOOM_MESSAGE.value
          settings.zoomMessage.issuedDateTime = new Date(
            dbSettings.ZOOM_MESSAGE.issued
          )
          settings.zoomMessage.issuedBy = dbSettings.ZOOM_MESSAGE.issuer_name
          console.log('VALUE OF ZOOM REDIRECT', dbSettings.ZOOM_REDIRECT.value)
          settings.zoomMessage.enabled =
            dbSettings.ZOOM_REDIRECT.value === '0' ? false : true

          // Set event id information to state
          settings.eventID.vimeoID = dbSettings.EVENT_ID.value
          settings.eventID.issuedDateTime = new Date(dbSettings.EVENT_ID.issued)
          settings.eventID.issuedBy = dbSettings.EVENT_ID.issuer_name

          // Save offline message to state
          settings.offlineMessage.message = dbSettings.OFFLINE_MESSAGE.value
          settings.offlineMessage.issuedDateTime = new Date(
            dbSettings.OFFLINE_MESSAGE.issued
          )
          settings.offlineMessage.issuedBy =
            dbSettings.OFFLINE_MESSAGE.issuer_name

          // Save zoom link to state
          settings.zoomLink.link = dbSettings.ZOOM_LINK.value
          settings.zoomLink.issuedDateTime = new Date(
            dbSettings.ZOOM_LINK.issued
          )
          settings.zoomLink.issuedBy = dbSettings.ZOOM_LINK.issuer_name

          // Save online status to state
          settings.onlineStatus.isOnline = dbSettings.IS_LIVE.value
          settings.onlineStatus.issuedDateTime = new Date(
            dbSettings.IS_LIVE.issued
          )
          settings.onlineStatus.issuedBy = dbSettings.IS_LIVE.issuer_name

          // Save browser refresh to state
          settings.browserRefresh.issuedDateTime = new Date(
            dbSettings.BROWSER_REFRESH.issued
          )
          settings.browserRefresh.issuedBy =
            dbSettings.BROWSER_REFRESH.issuer_name

          console.log(dbSettings)
          settings.isLive = dbSettings.IS_LIVE.value

          this.setState({ liveStreamSettings: settings })

          console.log(this.state)
        }
      })
      .catch(error => { })
  }

  showModal = type => {
    var state = this.state
    state[type] = true

    this.setState(state)
  }

  hideAllModals = () => {
    this.setState({
      showSubmitEventIDModal: false,
      showSubmitOfflineMessageModal: false,
      showSubmitZoomRedirectMessageModal: false,
      showSubmitZoomLinkModal: false,
      showToggleZoomRedirect: false,
      showToggleLiveStreamModal: false,
      showRefreshBrowsersModal: false,
      showFullViewThresholdModal: false,
      modalMessage: ''
    })
  }

  confirmRefreshBrowsers = () => {
    axios
      .patch(`${SETTINGS_URL}/livestream/refresh`, tokenize())
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully refreshed client browsers.'
          })
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to refresh client browsers. Refresh your browser and try again.'
          })
        }
      })
      .catch(serverError => {
        this.setState({
          modalSuccess: false,
          modalMessage:
            'Failed to refresh client browsers. If issue persists after browser refresh. Contact Support.'
        })
      })
  }

  updateLiveEventField = event => {
    var newValue = event.target.value
    var liveStreamSettings = this.state.liveStreamSettings

    liveStreamSettings.eventID.vimeoID = newValue
    this.setState({ liveStreamSettings })
  }

  updateOfflineMessage = event => {
    var newValue = event.target.value
    var liveStreamSettings = this.state.liveStreamSettings

    liveStreamSettings.offlineMessage.message = newValue
    this.setState({ liveStreamSettings })
  }

  updateFullViewThreshold = event => {
    var newValue = event.target.value

    if (
      /^[1-9][0-9]?$|^100$/.test(newValue) &&
      newValue !== 'e' &&
      newValue > 0 &&
      newValue <= 100
    ) {
      console.log(newValue)
      this.setState({ fullViewThreshold: newValue })
    }

    if (newValue === '') {
      this.setState({ fullViewThreshold: '' })
    }
  }

  submitNewMessage = () => {
    var newMessage = this.state.liveStreamSettings.offlineMessage.message

    axios
      .patch(
        `${SETTINGS_URL}/livestream/offlineMessage`,
        tokenize({ newMessage })
      )
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully updated offline message.'
          })
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to update offline message. Refresh and try again'
          })
        }
      })
      .catch(error => {
        console.log(error => {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to submit new message. If issue persists call support.'
          })
        })
      })
  }

  updateZoomLink = event => {
    var newValue = event.target.value
    var liveStreamSettings = this.state.liveStreamSettings

    liveStreamSettings.zoomLink.link = newValue
    this.setState({ liveStreamSettings })
  }

  updateZoomMessage = event => {
    var newValue = event.target.value
    var liveStreamSettings = this.state.liveStreamSettings

    liveStreamSettings.zoomMessage.message = newValue
    this.setState({ liveStreamSettings })
  }

  updateZoomMessageButton = event => {
    var liveStreamSettings = this.state.liveStreamSettings
    liveStreamSettings.zoomMessage.enabled = !liveStreamSettings.zoomMessage
      .enabled
    this.setState({ liveStreamSettings })
  }

  submitNewZoomLink = () => {
    // Submit new zoom link
    var newLink = this.state.liveStreamSettings.zoomLink.link

    axios
      .patch(`${SETTINGS_URL}/livestream/zoomLink`, tokenize({ newLink }))
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully updated zoom link.'
          })
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to update zoom link. Refresh and try again'
          })
        }
      })
      .catch(error => {
        console.log(error => {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to submit new zoom link message. If issue persists call support.'
          })
        })
      })
  }

  submitNewZoomRedirectMessage = () => {
    var newMessage = this.state.liveStreamSettings.zoomMessage.message

    axios
      .patch(
        `${SETTINGS_URL}/livestream/zoomRedirectMessage`,
        tokenize({ newMessage })
      )
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully updated zoom redirect message.'
          })
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to update zoom redirect message. Refresh and try again'
          })
        }
      })
      .catch(error => {
        console.log(error => {
          this.setState({
            modalSuccess: false,
            modalMessage:
              'Failed to submit new zoom redirect message. If issue persists call support.'
          })
        })
      })
  }

  submitChangeRedirectState = () => {
    var toggleState =
      this.state.liveStreamSettings.zoomMessage.enabled === true ? '0' : '1'

    axios
      .patch(
        `${SETTINGS_URL}/livestream/zoomRedirectToggle`,
        tokenize({ toggleState })
      )
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          var liveStreamSettings = this.state.liveStreamSettings
          liveStreamSettings.zoomMessage.enabled = !liveStreamSettings
            .zoomMessage.enabled
          this.setState({ liveStreamSettings })
          this.setState({
            modalSuccess: true,
            modalMessage: `Successfully ${liveStreamSettings.zoomMessage.enabled ? 'enabled' : 'disabled'
              } the redirect toggle.`
          })
        } else {
          var liveStreamSettings2 = this.state.liveStreamSettings2
          this.setState({
            modalSuccess: false,
            modalMessage: `Failed to ${liveStreamSettings2.zoomMessage.enabled ? 'enable' : 'disable'
              } the redirect toggle. Refresh and try again`
          })
        }
      })
      .catch(error => {
        console.log(error => {
          var liveStreamSettings3 = this.state.liveStreamSettings3
          this.setState({
            modalSuccess: false,
            modalMessage: `Failed to ${liveStreamSettings3.zoomMessage.enabled ? 'enable' : 'disable'
              } the redirect toggle.. If issue persists call support.`
          })
        })
      })
  }

  changeEventId = () => {
    var newEventID = this.state.liveStreamSettings.eventID.vimeoID

    axios
      .patch(`${SETTINGS_URL}/livestream/id`, tokenize({ newEventID }))
      .then(response => {
        var payload = response.data
        console.log(payload)
        if (payload.success) {
          this.setState({
            modalSuccess: true,
            modalMessage: 'Successfully updated live event ID.'
          })
        } else {
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to update live event ID.'
          })
        }
      })
      .catch(error => {
        console.log(error => {
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to update live event ID.'
          })
        })
      })
  }

  toggleLiveStreamStatus = () => {
    // toggle a live stream online/offine

    // eslint-disable-next-line
    if (this.state.liveStreamSettings.onlineStatus.isOnline == true) {
      console.log('STOP LIVESTREAM')
      axios
        .patch(`${SETTINGS_URL}/livestream/offline`, tokenize())
        .then(response => {
          var payload = response.data
          console.log(payload)
          if (payload.success) {
            this.setState({
              modalSuccess: true,
              modalMessage: 'Live stream stopped.'
            })
          } else {
            this.setState({
              modalSuccess: false,
              modalMessage: 'Failed to stop live stream.'
            })
          }
        })
        .catch(error => {
          console.log(error => {
            this.setState({
              modalSuccess: false,
              modalMessage: 'Failed to stop live stream.'
            })
          })
        })
    } else {
      console.log('START LIVESTREAM')
      axios
        .patch(`${SETTINGS_URL}/livestream/online`, tokenize())
        .then(response => {
          var payload = response.data
          console.log(payload)
          if (payload.success) {
            this.setState({
              modalSuccess: true,
              modalMessage: 'Live stream is now online'
            })
          } else {
            this.setState({
              modalSuccess: false,
              modalMessage: 'Failed to start live stream.'
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.setState({
            modalSuccess: false,
            modalMessage: 'Failed to start live stream.'
          })
        })
    }
  }

  renderModalResponse = () => (
    // Render the resonse from the server in the modal
    <div>
      <div
        className={
          this.state.modalSuccess ? 'alert alert-success' : 'alert alert-danger'
        }
      >
        {this.state.modalMessage}
      </div>
      <button
        className='btn btn-secondary'
        onClick={() => setTimeout(this.handleModalClose, 500)}
      >
        Done
      </button>
    </div>
  )

  handleModalClose = () => {
    this.hideAllModals()
    this.fetchLiveStreamSettings()
  }

  render() {
    // Convert datetime objects to readable strings
    var eventModificationDateTime = this.state.liveStreamSettings.eventID.issuedDateTime.toLocaleString()
    var messageModificationDateTime = this.state.liveStreamSettings.offlineMessage.issuedDateTime.toLocaleString()
    var zoomLinkModficationDateTime = this.state.liveStreamSettings.zoomLink.issuedDateTime.toLocaleString()
    var zoomMessageModificationDateTime = this.state.liveStreamSettings.zoomMessage.issuedDateTime.toLocaleString()
    var statusModificationDateTime = this.state.liveStreamSettings.onlineStatus.issuedDateTime.toLocaleString()
    var browserRefreshDateTime = this.state.liveStreamSettings.browserRefresh.issuedDateTime.toLocaleString()

    // Variable to store if livestream is online (Use as boolean, DB uses '1' or '0' as a string)
    // eslint-disable-next-line
    var liveStreamOnline =
      this.state.liveStreamSettings.onlineStatus.isOnline === '1' ? true : false

    // Variable to store message length
    var messageLength = this.state.liveStreamSettings.offlineMessage.message
      .length

    // Variable to store zoomMessage length
    var zoomMessageLength = this.state.liveStreamSettings.zoomMessage.message
      .length

    return (
      <div className="container">
        <AdminNavbar />
        <h1 className='pageTitle'>Settings</h1>

        <div className='card'>
          <div className='card-header'>
            <h3 className='card-title'>Live Stream Settings</h3>
            <p className='card-subtitle'>
              Do not touch these settings unless you're absolutely sure of what
              you are about to perform.
            </p>
          </div>

          <div className='card-body'>
            <label htmlFor='liveEventIDField'>Vimeo Live Event ID</label>
            <div className='input-group mb-3'>
              <input
                id='liveEventIDField'
                type='text'
                className='form-control'
                placeholder='Vimeo live event ID'
                value={this.state.liveStreamSettings.eventID.vimeoID}
                onChange={this.updateLiveEventField}
              />
              <div className='input-group-append'>
                <button
                  className='btn btn-primary'
                  type='button'
                  onClick={() => this.showModal('showSubmitEventIDModal')}
                >
                  Change Live Event ID
                </button>
              </div>
            </div>

            <div>
              Last modified by: {this.state.liveStreamSettings.eventID.issuedBy}{' '}
              {eventModificationDateTime}{' '}
            </div>

            <hr />

            <label htmlFor='fullViewThreshold'>Full View Threshold</label>
            <div className='input-group mb-3'>
              <input
                id='fullViewThreshold'
                type='text'
                className='form-control'
                placeholder='25%..'
                value={this.state.fullViewThreshold}
                onChange={this.updateFullViewThreshold}
              />
              <div className='input-group-append'>
                <button
                  className='btn btn-primary'
                  type='button'
                  onClick={() => this.showModal('showFullViewThresholdModal')}
                >
                  Change Full Video Threshold
                </button>
              </div>
            </div>

            <div>
              Last modified by:{' '}
              {this.state.fullViewThresholdModified.toLocaleString()}
            </div>

            <hr />

            <label htmlFor='offlineMessage'>Offline Message</label>
            <div className='input-group mb-3'>
              <textarea
                className='form-control'
                id='offlineMessage'
                rows='3'
                placeholder='Enter a message to display while livestream is offline...'
                value={this.state.liveStreamSettings.offlineMessage.message}
                onChange={this.updateOfflineMessage}
              ></textarea>
            </div>

            <div>
              <span>
                <span
                  className={messageLength > MESSAGE_LIMIT ? 'redText' : ''}
                >
                  {messageLength}
                </span>
                /{MESSAGE_LIMIT}
              </span>
            </div>

            {// If message length exceeds limit do not allow them to submit
              messageLength > MESSAGE_LIMIT ? (
                <button
                  title='Message length exceeded limit'
                  className='btn btn-danger inputFormTopMargin'
                  disabled
                >
                  Save Message
                </button>
              ) : (
                <button
                  className='btn btn-primary inputFormTopMargin'
                  onClick={() => this.showModal('showSubmitOfflineMessageModal')}
                >
                  Save Message
                </button>
              )}

            <div className='inputFormTopMargin'>
              Last modified by{' '}
              {this.state.liveStreamSettings.zoomMessage.issuedBy}{' '}
              {messageModificationDateTime}
            </div>
            <hr />

            {/* Zoom Redirection */}

            <label htmlFor='zoomLinkField'>Zoom Redirection Link</label>
            <div className='input-group mb-3'>
              <input
                id='zoomLinkField'
                type='text'
                className='form-control'
                placeholder='Zoom Link'
                value={this.state.liveStreamSettings.zoomLink.link}
                onChange={this.updateZoomLink}
              />
              <div className='input-group-append'>
                <button
                  className='btn btn-primary'
                  type='button'
                  onClick={() => this.showModal('showSubmitZoomLinkModal')}
                >
                  Change Zoom Link
                </button>
              </div>
            </div>
            <div>
              Last modified by:{' '}
              {this.state.liveStreamSettings.zoomLink.issuedBy}{' '}
              {zoomLinkModficationDateTime}{' '}
            </div>

            <hr />

            <label htmlFor='zoomMessage'>Live Redirect Message</label>
            <div className='input-group mb-3'>
              <textarea
                className='form-control'
                id='zoomMessage'
                rows='3'
                placeholder='Enter a message to display for redirect...'
                value={this.state.liveStreamSettings.zoomMessage.message}
                onChange={this.updateZoomMessage}
              ></textarea>
            </div>

            <div className='d-flex justify-content-between'>
              <span>
                <span
                  className={zoomMessageLength > MESSAGE_LIMIT ? 'redText' : ''}
                >
                  {zoomMessageLength}
                </span>
                /{MESSAGE_LIMIT}
              </span>
              <div className='custom-control custom-switch'>
                <input
                  className='zoomMessageSwitch custom-control-input'
                  type='checkbox'
                  id='zoomMessageSwitch'
                  checked={this.state.liveStreamSettings.zoomMessage.enabled}
                  onChange={() => this.showModal('showToggleZoomRedirect')}
                />
                <label
                  className='custom-control-label'
                  htmlFor='zoomMessageSwitch'
                >
                  Enable Redirect
                </label>
              </div>
            </div>

            {// If message length exceeds limit do not allow them to submit
              zoomMessageLength > MESSAGE_LIMIT ? (
                <button
                  title='Message length exceeded limit'
                  className='btn btn-danger inputFormTopMargin'
                  disabled
                >
                  Save Redirect Message
                </button>
              ) : (
                <button
                  className='btn btn-primary inputFormTopMargin'
                  onClick={() =>
                    this.showModal('showSubmitZoomRedirectMessageModal')
                  }
                >
                  Save Redirect Message
                </button>
              )}

            <div className='inputFormTopMargin'>
              Last modified by{' '}
              {this.state.liveStreamSettings.zoomMessage.issuedBy}{' '}
              {zoomMessageModificationDateTime}
            </div>
            <hr />

            {// If live display the STOP LIVESTREAM BUTTON or vice versa
              liveStreamOnline === true ? (
                <div>
                  <p className='greenText'>
                    <button
                      className='btn btn-outline-success'
                      type='button'
                      disabled
                    >
                      <span
                        className='spinner-grow spinner-grow-sm'
                        role='status'
                        aria-hidden='true'
                      ></span>
                      <span className='sr-only'>Loading...</span>
                    </button>
                    &nbsp;Live stream is&nbsp;
                    <span className='greenText underline'>online</span>
                  </p>
                  <button
                    onClick={() => this.showModal('showToggleLiveStreamModal')}
                    className='btn btn-danger'
                  >
                    Stop Live Stream
                  </button>
                </div>
              ) : (
                <div>
                  <p>
                    Live stream is <span className='redText'>offline</span>
                  </p>
                  <button
                    onClick={() => this.showModal('showToggleLiveStreamModal')}
                    className='btn btn-success'
                  >
                    Start Live Stream
                  </button>
                </div>
              )}
            <div className='inputFormTopMargin'>
              {liveStreamOnline === true ? 'Started' : 'Stopped'} by{' '}
              {this.state.liveStreamSettings.onlineStatus.issuedBy}{' '}
              {statusModificationDateTime}
            </div>
            <hr />

            <button
              className='btn btn-warning'
              onClick={() => this.showModal('showRefreshBrowsersModal')}
            >
              Refresh Client Browsers
            </button>
            <div className='inputFormTopMargin'>
              Last refreshed by:{' '}
              {this.state.liveStreamSettings.browserRefresh.issuedBy}{' '}
              {browserRefreshDateTime}
            </div>
          </div>
        </div>

        <AccountSettings />
        <LandingPageSettings />

        {/* Change live event ID modal */}
        <Modal
          show={this.state.showSubmitEventIDModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Live Event ID</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to change the live event to{' '}
            {this.state.liveStreamSettings.eventID.vimeoID}?
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button variant='warning' onClick={this.changeEventId}>
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Change Full View Threshold */}
        <Modal
          show={this.state.showFullViewThresholdModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Full View Threshold</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to change full view threshold to{' '}
            {this.state.fullViewThreshold}%?
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button variant='warning' onClick={this.patchFullViewThreshold}>
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Change live stream offline message modal */}
        <Modal
          show={this.state.showSubmitOfflineMessageModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Offline Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Confirm you want to change the offline message to:
            <br />
            <br />
            {this.state.liveStreamSettings.offlineMessage.message
              .split('\n')
              .map((line, index) => {
                return (
                  <div key={index}>
                    {line}
                    <br />
                  </div>
                )
              })}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button variant='warning' onClick={this.submitNewMessage}>
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Update Zoom Link Modal */}
        <Modal
          show={this.state.showSubmitZoomLinkModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Zoom Link</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Confirm you want to change the Zoom link to:
            <br />
            <br />
            {this.state.liveStreamSettings.zoomLink.link}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button variant='warning' onClick={this.submitNewZoomLink}>
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Zoom Redirect Message Modal */}
        <Modal
          show={this.state.showSubmitZoomRedirectMessageModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Change Redirect Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Confirm you want to change the redirect message to:
            <br />
            <br />
            {this.state.liveStreamSettings.zoomMessage.message
              .split('\n')
              .map((line, index) => {
                return (
                  <div key={index}>
                    {line}
                    <br />
                  </div>
                )
              })}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button
                  variant='warning'
                  onClick={this.submitNewZoomRedirectMessage}
                >
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Zoom Redirect Toggle */}
        <Modal
          show={this.state.showToggleZoomRedirect}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Enable/Disable Redirect</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Confirm you want to toggle the Redirect to:
            <br />
            <br />
            {this.state.liveStreamSettings.zoomMessage.enabled ? (
              <p>Disabled</p>
            ) : (
              <p>Enabled</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button
                  variant='warning'
                  onClick={this.submitChangeRedirectState}
                >
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Start/stop live stream modal */}

        <Modal
          show={this.state.showToggleLiveStreamModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {liveStreamOnline === true
                ? 'Stop Live Stream'
                : 'Start Live Stream'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Confirm {liveStreamOnline === true ? 'stop' : 'start'} the
            livestream?
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>

                {liveStreamOnline === true ? (
                  <Button
                    variant='danger'
                    onClick={this.toggleLiveStreamStatus}
                  >
                    Stop Live Stream
                  </Button>
                ) : (
                  <Button
                    variant='success'
                    onClick={this.toggleLiveStreamStatus}
                  >
                    Start Live Stream
                  </Button>
                )}
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>

        {/* Refresh web browsers modal */}
        <Modal
          show={this.state.showRefreshBrowsersModal}
          onHide={this.handleModalClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Refresh Member Browsers</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to refresh client web browsers?
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalMessage === '' ? (
              <div>
                <Button variant='secondary' onClick={this.handleModalClose}>
                  Cancel
                </Button>
                <Button variant='warning' onClick={this.confirmRefreshBrowsers}>
                  Proceed
                </Button>
              </div>
            ) : (
              this.renderModalResponse()
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default SettingsPage
